import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import ResearcherDashboard from "../../pages/researcher/ResearcherDashboard";
import ResearcherSettingsPage from "../../pages/researcher/ResearcherSettingsPage";
import ProfilePage from "../../pages/researcher/Profile";
import ReportEditor from "../../pages/reports/ReportEditor";
import PaginatedTransactions from "../../pages/payments/PaginatedTransactions";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import PaginatedPrograms from "../../pages/programs/PaginatedPrograms";
import ProgramPage from "../../pages/programs/ProgramPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import RetestPage from "../../pages/retests/RetestPage";
import ResearcherChecklistProgramsPage from "../../pages/researcher/ResearcherChecklistProgramsPage";
import ResearcherChecklistItemsPage from "../../pages/researcher/ResearcherChecklistItemsPage";
import ChecklistItemWorkspace from "../../pages/researcher/ChecklistItemWorkspace";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const ResearcherRoutes = () => {
  return (
    <Routes>
      <Route index element={<ResearcherDashboard />} />

      <Route path="reports/:id/edit" element={<ReportEditor />} />
      <Route path="reports/new" element={<ReportEditor />} />
      <Route path="reports/new/:programId" element={<ReportEditor />} />

      <Route path="reports" element={<PaginatedReports />} />
      <Route path="reports/:id" element={<ReportPage />} />

      <Route path="programs" element={<PaginatedPrograms />} />
      <Route path="programs/:id" element={<ProgramPage />} />

      <Route path="/retests" element={<RetestManagement />} />
      <Route path="/retests/:retest_id" element={<RetestPage />} />



      <Route path="researcher-checklists" element={<ResearcherChecklistProgramsPage />} />
      <Route path="researcher-checklists/programs/:programId" element={<ResearcherChecklistItemsPage />} />
      <Route path="researcher-checklists/items/:itemId" element={<ChecklistItemWorkspace />} />

      <Route path="payments/*" element={<PaginatedTransactions />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="profile/edit/*" element={<ResearcherSettingsPage />} />
      <Route path="profile/*" element={<ProfilePage />} />
      <Route path="profile/:userId" element={<ProfilePage />} />

      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default ResearcherRoutes;
